var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4737 4.21053V6.72842C13.4737 6.72842 11.7979 6.73684 11.7895 6.72842V4.21053H9.26316C9.26316 4.21053 9.27158 2.53474 9.26316 2.52632H11.7895V0H13.4737V2.52632H16V4.21053H13.4737ZM10.9474 7.57895V5.05263H8.42105V2.52632H1.68421C0.757895 2.52632 0 3.28421 0 4.21053V14.3158C0 15.2421 0.757895 16 1.68421 16H11.7895C12.7158 16 13.4737 15.2421 13.4737 14.3158V7.57895H10.9474ZM1.68421 14.3158L4.21053 10.9474L5.89474 13.4737L8.42105 10.1053L11.7895 14.3158H1.68421Z",
    fill: "#4D55E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImageIcon);
export default __webpack_public_path__ + "static/media/add-image-icon.cb863f3f00789e079f6d10a9e22aca04.svg";
export { ForwardRef as ReactComponent };